import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import type { TooltipRenderProps } from 'react-joyride'

const TourTooltip = ({
  backProps,
  continuous,
  index,
  isLastStep,
  primaryProps,
  skipProps,
  step,
  tooltipProps,
  size,
}: TooltipRenderProps): JSX.Element => {
  const { t } = useTranslation()
  const showBack = index > 0

  return (
    <Paper
      {...tooltipProps}
      elevation={6}
      sx={{
        p: 3,
        maxWidth: 420,
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderRadius: 2,
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="caption" color="text.secondary">
          {t('tour.stepOf', { current: index + 1, total: size })}
        </Typography>

        {step.title ? (
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {step.title}
          </Typography>
        ) : null}

        <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
          {step.content}
        </Typography>

        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ pt: 1 }}>
          <Button {...skipProps} size="small" color="inherit">
            {t('tour.skip')}
          </Button>

          <Box sx={{ display: 'flex', gap: 1 }}>
            {showBack ? (
              <Button {...backProps} size="small" variant="outlined">
                {t('common.previous')}
              </Button>
            ) : null}
            <Button {...primaryProps} size="small" variant="contained">
              {continuous && !isLastStep ? t('common.next') : t('tour.finish')}
            </Button>
          </Box>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default TourTooltip
